import foreach from 'lodash.foreach';
import config from 'config';
import {ApolloClient, createNetworkInterface} from 'react-apollo';

const apolloApi = createNetworkInterface({
  uri: `${config.cove.api}/graphql`,
});

// Add Auth header to GraphQL calls
apolloApi.use([{
  applyMiddleware(req, next) {
    if (!req.options.headers) {
      req.options.headers = {};  // Create the header object if needed.
    }
    const authResult = JSON.parse(localStorage.getItem('authResult'));
    if (authResult) {
      req.options.headers.Authorization = `Bearer ${authResult.idToken}`;
    }
    next();
  },
}]);

// Record server errors in Sentry
const handleErrors = ({response}, next) => {
  // clone response so we can turn it into json independently
  const res = response.clone();
  if (!res.ok) {
    // handle network errors based on res.status here, for example:
    window.Raven.captureException(new Error(res.body));
    next();
  }


  // handle apollo errors
  res.json().then((json) => {
    if (json.errors) {
      foreach(json.errors, (error) => {
        if (error) {
          window.Raven.captureException(new Error(error.message));
        }
      });
    }
    next();
  });
};

apolloApi.useAfter([{
  applyAfterware: handleErrors,
}]);

const apollo = new ApolloClient({
  networkInterface: apolloApi,
});

module.exports = apollo;



// WEBPACK FOOTER //
// ./web/utils/apollo.js